// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"bec5113a900d7e3ef459","debug-page-model-style":"5f2580e99e12071992a6"}[chunkId] + ".css";
};